import React from 'react';
import { Modal } from 'antd';
import McpGuide from './McpGuide';
import { MCP_GUIDE_TEXT } from './mcpGuideContent';

interface McpGuideModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Окно «MCP» для embed: в монтировании на платформе шапки с окном «Документация» нет,
 * а гайд тот же, что во вкладке standalone.
 */
const McpGuideModal: React.FC<McpGuideModalProps> = ({ open, onClose }) => (
  <Modal open={open} onCancel={onClose} footer={null} width={900} title={MCP_GUIDE_TEXT.title} style={{ top: 40 }}>
    {open && <McpGuide />}
  </Modal>
);

export default McpGuideModal;
